import PerfectScrollbar from 'perfect-scrollbar';
import * as videoplayer from './video'
require('slick-carousel');

export function initalize() {
  const $slider = $('.property-slider');
  if (!$slider.length) return;
  const $track = $slider.find('.property-slider-track');
  var scrollbar = new PerfectScrollbar($('.property-slider-thumbnails-col')[0]);
  setTimeout(() => {
    $('.property-slider-thumbnails img').each(function(i) {
      setTimeout(() => {
        $(this).attr('src', $(this).data('src'));
        scrollbar.update();
      }, 300 * i);
    });
  }, 1000);
  const $img = $track.find('img');
  const notDone = $img.length && (!$img[0].complete || $img[0].naturalWidth === 0);
  if (!$img.length || !notDone) {
    initSlideShow();
  } else {
    $img.one('load', initSlideShow);
  }
}

async function initSlideShow() {
  const $video = $('.property-video');
  let player = null;
  if ($video.length > 0) {
    videoplayer.player($video[0], {
      ratio: '16:9',
      loop: {
        active: true,
      },
      autoplay: false,
    }).then(p => {
      player = p;
    });
  }
  const $slider = $('.property-slider');
  const $track = $slider.find('.property-slider-track');
  $('.property-slider-thumbnails img').each(function(i) {
    if (i > 0) {
      if (!$(this).attr('src')) {
        $(this).attr('src', $(this).data('src'));
      }
      const $image = $(this).parent().clone();
      $image.removeClass('aspect-ratio-5-3');
      $image.addClass('proper-size');
      $track.append($image);
    }
  });
  const slider = $track.slick({
    arrows: true,
    dots: false,
    swipe: true,
    infinite: true,
    slidesToShow: 1,
    prevArrow: $slider.find('.slick-prev'),
    nextArrow: $slider.find('.slick-next'),
  });
  $('.property-slider-thumbnails .thumbnail').each(function(i) {
    $(this).click(() => {
      slider.slick('slickGoTo', i, true);
    });
  });
  slider.on('beforeChange', function(e, s, c, index) {
    $('.property-slider-thumbnails .thumbnail').removeClass('active');
    const $current = $('.property-slider-thumbnails .thumbnail').eq(index);
    $current.addClass('active');
    if (isFullscreen()) {
      const $slide = $track.find('.slick-current');
      loadImage($slide.next());
      loadImage($slide.prev());
    }
  });
  slider.on('afterChange', function() {
    if (player) player.pause();
    const $slide = $track.find('.slick-current');
    if ($slide.find('img').length) {
      $slider.removeClass('fullscreen-hover-off');
    } else {
      $slider.addClass('fullscreen-hover-off');
    }
    loadImage($slide.next());
    loadImage($slide.prev());
  });
  if (hasFullscreen()) {
    $slider.on('click', () => {
      if (!isFullscreen() && !$slider.hasClass('fullscreen-hover-off')) {
        enterFullscreen($slider[0]);
      }
    });
  } else {
    $('.property-slider-fullscreen').hide();
    $('.property-slider-fullscreen-corner').hide();
    $slider.find('.slick-prev, .slick-next').show();
  }
}

function loadImage($slide) {
  const $img = $slide.find('img');
  if ($img.length && !$img.data('loading')) {
    const src = 'https://cdn.photos.sparkplatform.com/lou/' + $img.attr('src').split('/').pop();
    const image = new Image();
    image.onload = () => {
      console.log($slide[0]);
      $img.attr('src', src);
    };
    image.src = src;
    $img.data('loading', true);
  }
}

function hasFullscreen() {
  return ('fullscreenEnabled' in document ||
          'webkitFullscreenEnabled' in document ||
          'mozFullScreenEnabled' in document ||
          'msFullscreenEnabled' in document) &&
      (document.fullscreenEnabled || document.webkitFullscreenEnabled ||
       document.mozFullScreenEnabled || document.msFullscreenEnabled);
}

function enterFullscreen(element) {
  if ('requestFullscreen' in element) {
    element.requestFullscreen();
  } else if ('webkitRequestFullscreen' in element) {
    element.webkitRequestFullscreen();
  } else if ('mozRequestFullScreen' in element) {
    element.mozRequestFullScreen();
  } else if ('msRequestFullscreen' in element) {
    element.msRequestFullscreen();
  }
}

function isFullscreen() {
  return document.fullscreenElement || document.webkitFullscreenElement ||
      document.mozFullScreenElement || document.msFullscreenElement;
}

function exitFullscreen() {
  if ('exitFullscreen' in document) {
    document.exitFullscreen();
  } else if ('webkitExitFullscreen' in document) {
    document.webkitExitFullscreen();
  } else if ('mozCancelFullScreen' in document) {
    document.mozCancelFullScreen();
  } else if ('msExitFullscreen' in document) {
    document.msExitFullscreen();
  }
}

// function screenchange() {
//   if (!isFullscreen()) {
//     exitFullscreen();
//   }
// }

// document.addEventListener('fullscreenchange', screenchange);
// document.addEventListener('webkitfullscreenchange', screenchange);
// document.addEventListener('mozfullscreenchange', screenchange);
// document.addEventListener('MSFullscreenChange', screenchange);
